import { Checkbox } from "@/components/ui/checkbox";
import { cn } from "@/utils/cn";
import { textVariants } from "@/utils/text-variants";
import { memo } from "react";

interface ShoppingListItemProps {
  ingredientId: string;
  ingredientName: string;
  isTicked: boolean;
  onToggle: () => void;
}

/**
 * A single row in the shopping list.
 * Tapping anywhere on the row toggles the checked state.
 */
export const ShoppingListItem = memo(function ShoppingListItem({
  ingredientName,
  isTicked,
  onToggle,
}: ShoppingListItemProps) {
  return (
    <button
      type="button"
      className={cn(
        "flex w-full items-start gap-4",
        "cursor-pointer transition-opacity duration-200",
        "text-left",
      )}
      onClick={onToggle}
    >
      <Checkbox checked={isTicked} readOnly />

      <span
        className={cn(textVariants.bodySmall, "flex-1", {
          "text-gray-400 line-through": isTicked,
          "text-black": !isTicked,
        })}
      >
        {ingredientName}
      </span>
    </button>
  );
});
